import {
  UPDATE_DESKTOP_PREFERENCES_SUCCESS,
  DESKTOP_PREFERENCES_SUCCESS,
  UPDATE_MOBILE_PREFERENCES_SUCCESS,
  MOBILE_PREFERENCES_SUCCESS,
  UPDATE_EMAIL_PREFERENCES_SUCCESS,
  EMAIL_PREFERENCES_SUCCESS,
  SUB_LOCATION_NOTIFICATION_PREFERENCES_SUCCESS,
  UPDATE_SUB_LOCATION_NOTIFICATION_PREFERENCES_SUCCESS,
} from '../actions/settings'

export default function (state = {}, action) {
  switch (action.type) {
    case UPDATE_DESKTOP_PREFERENCES_SUCCESS:
    case DESKTOP_PREFERENCES_SUCCESS:
      return {
        ...state,
        desktopPreferences: {
          ...state.desktopPreferences,
          issues: action.payload.issues,
          servicingCompletions: action.payload.servicingCompletions,
          unsatisfactory: action.payload.unsatisfactory,
          delayed: action.payload.delayed,
        }
      }

    case UPDATE_MOBILE_PREFERENCES_SUCCESS:
    case MOBILE_PREFERENCES_SUCCESS:
      return {
        ...state,
        mobilePreferences: {
          ...state.mobilePreferences,
          issues: action.payload.issues,
          servicingCompletions: action.payload.servicingCompletions,
          unsatisfactory: action.payload.unsatisfactory,
        }
      }

    case UPDATE_EMAIL_PREFERENCES_SUCCESS:
    case EMAIL_PREFERENCES_SUCCESS:
      return {
        ...state,
        emailPreferences: {
          ...state.emailPreferences,
          permanentIssues: action.payload.permanentIssues,
          unsatisfactory: action.payload.unsatisfactory,
          emergencyServices: action.payload.emergencyServices,
          billable: action.payload.billable,
          delayed: action.payload.delayed,
          workOrderDelay: action.payload.workOrderDelay,
          unableToComplete: action.payload.unableToComplete,
          needsWork: action.payload.needsWork,
          needsReview: action.payload.needsReview,
          workTrackerMonthlyReports: action.payload.workTrackerMonthlyReports
        }
      }

    case UPDATE_SUB_LOCATION_NOTIFICATION_PREFERENCES_SUCCESS:
    case SUB_LOCATION_NOTIFICATION_PREFERENCES_SUCCESS: {
      return {
        ...state,
        subLocationPreferences: action.payload.subLocations.map(sl => sl.id)
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/settings.js